import { create } from "zustand";

export const useDetailsStore = create((set, get) => ({
  customerDetails: {
    addressFromStr: "",
    addressToStr: "",
    addressFromArray: {},
    addressToArray: {},
    moveOutDate: "",
    moveInDate: "",
    emailFrom: "",
    emailTo: "",
    givenNameFrom: "",
    givenNameTo: "",
    middleNameFrom: "",
    middleNameTo: "",
    familyNameFrom: "",
    familyNameTo: "",
    mobileNumberFrom: "",
    mobileNumberTo: "",
    genderFromDesc: "",
    genderToDesc: "",
    genderFromId: 0,
    genderToId: 0,
  },

  files: [],
  filesPaths: [],

  customerId: 0,

  setCustomerDetails: (name, value) => {
    const { customerDetails } = get();

    set((state) => ({
      customerDetails: { ...state.customerDetails, [name]: value },
    }));

    sessionStorage.setItem("LS_DETAILS", JSON.stringify(customerDetails));
  },

  setFiles: (files) => set({ files }),

  setFilesPaths: (filesPaths) => set({ filesPaths }),

  setCustomerId: (id) => {
    set((state) => {
      sessionStorage.setItem("LS_CUSTOMER_ID", id);
      return { customerId: id };
    });
  },
}));
